// msal-config.ts (example skeleton)
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from './environments/environment';

function hasRealScopes(scopes: string[]): boolean {
  return scopes.length > 0 && scopes.every((scope) => !scope.includes('<') && !scope.includes('>'));
}

export function resolveScopesForUrl(url: string): string[] | null {
  const resources: Array<[string, string[]]> = [
    [environment.url.api_generic_tools, environment.AZURE_SCOPES.genericTools],
    [environment.url.api_abaco, environment.AZURE_SCOPES.abaco]
  ];

  const resource = resources.find(([baseUrl]) => url === baseUrl || url.startsWith(`${baseUrl}/`));
  return resource && hasRealScopes(resource[1]) ? resource[1] : null;
}

export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: '20314930-76aa-46a6-acd6-a348eb04bf47',
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      redirectUri: environment.redirects.redirectUrlSignIn
    },
    cache: {
      cacheLocation: 'localStorage'
    },
    system: {
      tokenRenewalOffsetSeconds: 300
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  // const apiVisa = `${environment.url.api_visa}/*`;
  const apiGenericTools = `${environment.url.api_generic_tools}/*`;
  const apiAbaco = `${environment.url.api_abaco}/*`;
  
  const resourceEntries: Array<[string, string[]]> = [
    [apiGenericTools, environment.AZURE_SCOPES.genericTools],
    [apiAbaco, environment.AZURE_SCOPES.abaco]
    // [apiVisa, environment.AZURE_SCOPES.visa]
  ];
  const protectedResources = resourceEntries.filter((entry) => hasRealScopes(entry[1]));

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map(protectedResources)
  };
}
